var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChillblastLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1007.38 201.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.32,35.13h23.42v39.44c2.99-2.82,10.74-10.21,25.35-10.21,10.92,0,23.07,5.99,30.11,14.97,7.75,9.86,7.75,23.77,7.75,30.99v55.11h-23.42v-50c0-10.56-.7-29.58-20.07-29.58s-19.72,21.66-19.72,29.93v49.65h-23.42V35.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.65,35.13h23.42v21.48h-23.42v-21.48ZM490.65,67.7h23.42v97.72h-23.42v-97.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M532.36,35.13h23.42v130.29h-23.42V35.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.89,35.13h23.42v130.29h-23.42V35.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.18,35.13h23.42v41.38c8.1-8.1,19.54-12.15,30.46-12.15,29.76,0,49.12,25.88,49.12,51.76,0,19.54-12.85,52.47-48.59,52.47-18.84,0-27.11-8.45-32.92-14.97v11.8h-21.48V35.13ZM665.59,147.11c15.32,0,28.17-11.8,28.17-30.81s-13.73-30.46-28.52-30.46c-17.96,0-29.05,15.14-29.05,29.4,0,21.66,15.67,31.87,29.4,31.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729.69,35.13h23.42v130.29h-23.42V35.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M869.24,165.42h-21.48v-12.15c-7.39,8.8-21.83,15.32-34.16,15.32-25.18,0-47.54-20.07-47.54-52.64,0-29.93,21.83-51.59,48.95-51.59,19.9,0,31.69,14.26,32.4,15.67h.35v-12.33h21.48v97.72ZM818.53,85.84c-19.19,0-29.05,16.55-29.05,31.17,0,16.55,12.33,30.11,29.05,30.11s28.52-12.68,28.52-30.81c0-20.25-14.61-30.46-28.52-30.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M924.17,94.29c-1.59-7.75-6.87-8.45-9.33-8.45-5.81,0-8.98,4.4-8.98,8.45,0,5.63,4.05,6.87,16.55,10.92,12.15,3.7,27.29,9.51,27.29,29.23,0,22.01-17.43,34.16-34.16,34.16-9.68,0-21.66-3.34-29.23-12.85-5.99-7.4-6.87-15.14-7.4-21.13h23.95c1.06,4.4,3.17,12.5,12.85,12.5,7.57,0,10.56-5.81,10.56-9.86,0-7.22-5.28-8.98-22.01-14.61-11.09-3.7-21.83-11.97-21.83-28,0-19.02,17.08-30.28,32.75-30.28,14.61,0,30.99,10.56,31.87,29.93h-22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M969.88,88.48h-13.46v-20.78h13.46v-32.57h23.42v32.57h14.09v20.78h-14.09v76.94h-23.42v-76.94Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.25.34L27.97,0v27.97H0v72.55c0,55.32,44.86,100.52,100.52,100.52s100.52-44.86,100.52-100.52C200.7,46.89,158.87,3.37,106.25.34ZM136.42,117.14h27.21c-7.57,28.52-33.58,48.4-63.46,48.4-36.18,0-65.62-29.14-65.62-64.96S63.99,34.96,100.17,34.96c29.81,0,55.72,19.86,63.36,48.4h-27.13c-6.45-14.69-20.46-24.1-36.24-24.1-21.96,0-39.83,18.46-39.83,41.15s17.87,40.82,39.83,40.82c15.72,0,29.76-9.41,36.25-24.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.81,145.53c-24.83,0-44.02-20.95-44.02-45.07s19.54-45.43,44.02-45.43c18.26,0,33.75,11.38,40.45,27.54h25.29c-7.94-29.36-34.8-50.08-65.75-50.08-36.97,0-68.14,29.58-68.14,68.14s30.64,67.44,68.14,67.44c31.47,0,58.09-21.2,65.85-50.08h-25.37c-6.64,15.9-21.98,27.54-40.48,27.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChillblastLogoWhite);
export default __webpack_public_path__ + "static/media/chillblast-logo-white.2761be737c1b759bc368a941938d7ae0.svg";
export { ForwardRef as ReactComponent };